import "@/App.css";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import FeaturesSection from "./components/FeaturesSection";
import ServicesSection from "./components/ServicesSection";
import FounderSection from "./components/FounderSection";
import WhyUsSection from "./components/WhyUsSection";
import SurveyForm from "./components/SurveyForm";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookiePolicy from "./components/CookiePolicy";
import { Toaster } from "./components/ui/sonner";

function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Toaster position="top-center" richColors />
      <Header />
      
      <main>
        <HeroSection />
        
        {/* Top Survey Section */}
        <section id="survey-top" className="py-20 md:py-32 bg-blue-900">
          <div className="container mx-auto px-6 md:px-12 max-w-4xl">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-white/10 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
                KEZDJE EL MOST
              </div>
              <h2
                className="text-3xl md:text-5xl font-extrabold tracking-tight text-white mb-4"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                Kérjen ingyenes felmérést
              </h2>
              <p className="text-lg text-blue-100 max-w-2xl mx-auto">
                Töltse ki az alábbi kérdőívet, és szakértőink hamarosan felveszik Önnel a kapcsolatot.
              </p>
            </div>
            
            <SurveyForm />
          </div>
        </section>
        
        <AboutSection />
        <FeaturesSection />
        <ServicesSection />
        <FounderSection />
        <WhyUsSection />
        
        {/* Bottom Survey Section */}
        <section id="survey" className="py-20 md:py-32 bg-slate-50 geo-pattern">
          <div className="container mx-auto px-6 md:px-12 max-w-4xl">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                KAPCSOLATFELVÉTEL
              </div>
              <h2
                className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 mb-4"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                Kérjen ingyenes felmérést
              </h2>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto">
                Töltse ki az alábbi kérdőívet, és szakértőink hamarosan felveszik Önnel a kapcsolatot.
              </p>
            </div>
            
            <SurveyForm />
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/adatvedelem" element={<PrivacyPolicy />} />
      <Route path="/sutik" element={<CookiePolicy />} />
    </Routes>
  );
}

export default App;
